import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Big prev / next handles pinned to the page margins.
 * `contents` wrapper keeps the parent's space-y-* rules from nudging the second button down.
 */
export const EdgeNav = ({ onPrev, onNext, label = "period" }) => (
  <div className="contents">
    <button
      data-testid="edge-nav-prev"
      onClick={onPrev}
      aria-label={`Previous ${label}`}
      title={`Previous ${label}`}
      className="hidden md:grid fixed z-20 top-1/2 -translate-y-1/2 left-2 lg:left-[17rem] h-28 w-11 place-items-center rounded-sm border border-border bg-card/90 backdrop-blur-sm text-muted-foreground hover:text-foreground hover:bg-accent transition-colors duration-200"
    >
      <ChevronLeft className="h-7 w-7" />
    </button>
    <button
      data-testid="edge-nav-next"
      onClick={onNext}
      aria-label={`Next ${label}`}
      title={`Next ${label}`}
      className="hidden md:grid fixed z-20 top-1/2 -translate-y-1/2 right-2 h-28 w-11 place-items-center rounded-sm border border-border bg-card/90 backdrop-blur-sm text-muted-foreground hover:text-foreground hover:bg-accent transition-colors duration-200"
    >
      <ChevronRight className="h-7 w-7" />
    </button>
  </div>
);
